import { FC } from 'react';

interface Props {
  className?: string;
  width?: string;
  height?: string;
}

const ArrowSvg: FC<Props> = ({ className, width = '13', height = '8' }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 13 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.709473 8V3.41463H10.3292L6.79976 0H8.50701L12.7095 4L8.50701 8H6.79976L10.3292 4.58536H1.92425V8H0.709473Z"
        fill="#0B0B0B"
      />
    </svg>
  );
};

export default ArrowSvg;
